<template>
  <div class="manager-dashboard">
    <!-- Formulaire Feedback -->
    <feedback-form v-if="showFeedbackForm" @close="showFeedbackForm = false" />

    <!-- Formulaire Surplus -->
    <surplus-form v-if="showSurplusForm" @close="showSurplusForm = false" />

    <!-- Dashboard Principal -->
    <div v-if="!showFeedbackForm && !showSurplusForm" class="space-y-4">
      <!-- École Info -->
      <div class="bg-white rounded-xl p-4 shadow-sm">
        <h2 class="text-xl font-bold text-gray-800">🏫 Ecole Primaire de Lanta</h2>
        <p class="text-sm text-gray-500">Service du midi</p>
      </div>

      <!-- Repas du jour -->
      <div class="bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl p-6 text-white shadow-lg">
        <h3 class="text-lg font-bold mb-3">📊 REPAS DU JOUR</h3>
        <div class="bg-white bg-opacity-20 rounded-lg p-4 backdrop-blur">
          <div class="text-3xl font-bold">142 élèves</div>
          <div class="text-sm opacity-90">attendus</div>
        </div>
      </div>

      <!-- Alertes -->
      <div class="space-y-3">
        <h3 class="font-bold text-gray-800 flex items-center gap-2">
          <i class="alert-icon">⚠️</i>
          ALERTES (2)
        </h3>

        <div class="bg-red-50 border-l-4 border-red-500 rounded-lg p-4">
          <div class="flex items-start gap-3">
            <span class="text-red-600">📦</span>
            <div class="flex-1">
              <p class="font-semibold text-red-800">Surplus : 8kg à valoriser</p>
              <button class="text-red-600 text-sm font-medium mt-1 hover:underline">📍 Voir les associations</button>
            </div>
          </div>
        </div>

        <div class="bg-yellow-50 border-l-4 border-yellow-500 rounded-lg p-4">
          <div class="flex items-start gap-3">
            <span class="text-yellow-600">⚠️</span>
            <div class="flex-1">
              <p class="font-semibold text-yellow-800">Feedback en attente (3)</p>
              <button @click="showFeedbackForm = true" class="text-yellow-600 text-sm font-medium mt-1 hover:underline">
                👉 Compléter
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Statistiques -->
      <div class="bg-white rounded-xl p-4 shadow-sm">
        <h3 class="font-bold text-gray-800 mb-4">📈 STATISTIQUES SEMAINE</h3>
        <div class="grid grid-cols-2 gap-4">
          <div class="bg-green-50 rounded-lg p-4 text-center">
            <div class="text-3xl mb-1">😊</div>
            <div class="text-2xl font-bold text-green-600">78%</div>
            <div class="text-sm text-gray-600">Satisfaction</div>
          </div>
          <div class="bg-blue-50 rounded-lg p-4 text-center">
            <div class="text-3xl mb-1">📉</div>
            <div class="text-2xl font-bold text-blue-600">-12%</div>
            <div class="text-sm text-gray-600">Gaspillage</div>
          </div>
        </div>
      </div>

      <!-- NOUVEAU : Panneau Communication (EPIC 2) -->
      <communication-panel />

      <!-- NOUVEAU : Accès rapide au gaspillage -->
      <div class="bg-white rounded-xl p-4 shadow-sm">
        <h3 class="font-bold text-gray-800 mb-3">♻️ GASPILLAGE</h3>
        <button
          @click="showWasteViz = true"
          class="w-full bg-green-500 hover:bg-green-600 text-white rounded-lg p-3 font-semibold"
        >
          📊 Voir les statistiques
        </button>
      </div>

      <!-- Modal WasteVisualization -->
      <div v-if="showWasteViz" class="modal-overlay" @click="showWasteViz = false">
        <div class="modal-content-large" @click.stop>
          <waste-visualization />
          <button @click="showWasteViz = false" class="close-btn">✕</button>
        </div>
      </div>
      <!-- Actions rapides -->
      <div class="space-y-3">
        <h3 class="font-bold text-gray-800">🔗 ACTIONS RAPIDES</h3>
        <button
          @click="showFeedbackForm = true"
          class="w-full bg-blue-500 hover:bg-blue-600 text-white rounded-lg p-4 font-semibold shadow-md transition"
        >
          📝 Feedback du jour
        </button>
        <button
          @click="showSurplusForm = true"
          class="w-full bg-green-500 hover:bg-green-600 text-white rounded-lg p-4 font-semibold shadow-md transition"
        >
          📦 Déclarer un surplus
        </button>
        <button
          class="w-full bg-purple-500 hover:bg-purple-600 text-white rounded-lg p-4 font-semibold shadow-md transition"
        >
          📊 Voir les statistiques
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import FeedbackForm from "./FeedbackForm.vue"
import SurplusForm from "./SurplusForm.vue"
import CommunicationPanel from "@/components/CommunicationPanel.vue"
import WasteVisualization from "@/components/WasteVisualization.vue"

export default {
  name: "ManagerDashboard",
  components: {
    FeedbackForm,
    SurplusForm,
    CommunicationPanel,
    WasteVisualization,
  },
  data() {
    return {
      showFeedbackForm: false,
      showSurplusForm: false,
    }
  },
}
</script>

<style scoped>
.space-y-4 > * + * {
  margin-top: 1rem;
}

.space-y-3 > * + * {
  margin-top: 0.75rem;
}

.gap-2 {
  gap: 0.5rem;
}

.gap-3 {
  gap: 0.75rem;
}

.gap-4 {
  gap: 1rem;
}

.grid {
  display: grid;
}

.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.flex {
  display: flex;
}

.items-start {
  align-items: flex-start;
}

.items-center {
  align-items: center;
}

.flex-1 {
  flex: 1 1 0%;
}

.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}

.from-blue-500 {
  --tw-gradient-from: #3b82f6;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.to-blue-600 {
  --tw-gradient-to: #2563eb;
}

.backdrop-blur {
  backdrop-filter: blur(8px);
}

.bg-opacity-20 {
  --tw-bg-opacity: 0.2;
}

.rounded-xl {
  border-radius: 0.75rem;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.shadow-sm {
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
}

.shadow-md {
  box-shadow: 0 2px 4px -2px rgb(0 0 0 / 0.1);
}

.shadow-lg {
  box-shadow: 0 4px 6px -4px rgb(0 0 0 / 0.1);
}

.border-l-4 {
  border-left-width: 4px;
}

.border-red-500 {
  border-color: #ef4444;
}

.border-yellow-500 {
  border-color: #eab308;
}

.bg-red-50 {
  background-color: #fef2f2;
}

.bg-yellow-50 {
  background-color: #fefce8;
}

.bg-green-50 {
  background-color: #f0fdf4;
}

.bg-blue-50 {
  background-color: #eff6ff;
}

.bg-white {
  background-color: #ffffff;
}

.text-white {
  color: #ffffff;
}

.text-red-600 {
  color: #dc2626;
}

.text-red-800 {
  color: #991b1b;
}

.text-yellow-600 {
  color: #ca8a04;
}

.text-yellow-800 {
  color: #854d0e;
}

.text-green-600 {
  color: #16a34a;
}

.text-blue-600 {
  color: #2563eb;
}

.text-gray-500 {
  color: #6b7280;
}

.text-gray-600 {
  color: #4b5563;
}

.text-gray-800 {
  color: #1f2937;
}

.font-bold {
  font-weight: 700;
}

.font-semibold {
  font-weight: 600;
}

.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}

.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}

.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}

.p-4 {
  padding: 1rem;
}

.p-6 {
  padding: 1.5rem;
}

.mb-1 {
  margin-bottom: 0.25rem;
}

.mb-3 {
  margin-bottom: 0.75rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.mt-1 {
  margin-top: 0.25rem;
}

.w-full {
  width: 100%;
}

.opacity-90 {
  opacity: 0.9;
}

.text-center {
  text-align: center;
}

.transition {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

button {
  cursor: pointer;
  border: none;
  background: none;
}

button:hover {
  opacity: 0.9;
}

.hover\:underline:hover {
  text-decoration: underline;
}

.bg-blue-500 {
  background-color: #3b82f6;
}

.bg-blue-600 {
  background-color: #2563eb;
}

.hover\:bg-blue-600:hover {
  background-color: #2563eb;
}

.bg-green-500 {
  background-color: #22c55e;
}

.bg-green-600 {
  background-color: #16a34a;
}

.hover\:bg-green-600:hover {
  background-color: #16a34a;
}

.bg-purple-500 {
  background-color: #a855f7;
}

.bg-purple-600 {
  background-color: #9333ea;
}

.hover\:bg-purple-600:hover {
  background-color: #9333ea;
}
</style>
